import { Injectable } from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private userData: any = {};
  private studioData: any = {};

  constructor(
    private localSt: LocalStorageService,
  ) {
    if (this.localSt.retrieve('user')) {
      this.setUserData(this.localSt.retrieve('user'));
    }
    if (this.localSt.retrieve('studio')) {
      this.setOwnerStudio(this.localSt.retrieve('studio'));
    }
  }

  setUserData(userData) {
    Object.assign(this.userData, userData);
  }

  getUserData() {
    return this.userData;
  }

  clearUserData() {
    this.userData = {};
  }

  setOwnerStudio(studioData) {
    this.studioData = studioData;
  }

  getOwnerStudio() {
    return this.studioData;
  }

  clearOwnerStudio() {
    this.studioData = {};
  }

  logOutUser() {
    this.clearUserData();
    this.clearOwnerStudio();
    this.localSt.clear();
  }

  isAdmin() {
    return this.userData.role === 'admin';
  }

  isStudio() {
    return this.userData.role === 'partner';
  }

  isUser() {
    return this.userData.role === 'simple';
  }

}
